module.exports = __webpack_public_path__ + "static/media/eu.08362ccc.svg";